export const PRODUCT_SERVICE_FORM_NAME = 'serviceOrderCreateForm';
export const DATE = 'date';
export const TIME = 'time';
export const SEGMENT = 'segment';
export const CURRENCY = 'currency';
export const AMOUNT = 'amount';
export const TAX_RATE = 'taxRate';
export const NOTES = 'note';
export const UNITS = 'units';
export const UNIT_COST = 'unitCost';
export const UNIT_AMOUNT = 'unitAmount';
export const UNIT_CURRENCY = 'unitCurrency';
export const SERVICE_ID = 'serviceId';
export const CUSTOMER_ID = 'customerId';
